import { FormLabel, Grid, styled } from '@mui/material'

export const LabelStyle = styled(FormLabel)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
  fontSize: '1rem',
}))

export const StyledFormBottom = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}))

export const StyledGridColumn = styled(Grid)(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '2rem',
}))
